let marketsDataPromise: Promise<Record<number, { label: string }>> | null = null;

function fetchMarketsData(languageId: number): Promise<Record<number, { label: string }>> {
  if (marketsDataPromise) {
    return marketsDataPromise;
  }

  const endpoint = document.body.dataset.marketsDataEndpoint;
  if (!endpoint) {
    return Promise.resolve({});
  }

  const url = `${endpoint}?L=${languageId}`;

  marketsDataPromise = fetch(url)
    .then(response => {
      if (response.status === 200) {
        return response.json();
      }
      throw new Error('Failed to fetch markets data');
    })
    .catch(error => {
      console.error('Error fetching markets data:', error);
      marketsDataPromise = null;
      return {};
    });

  return marketsDataPromise;
}

export async function getMarketLabel(marketId: number, languageId: number): Promise<string> {
  const marketsData = await fetchMarketsData(languageId);
  return marketsData[marketId]?.label || '';
}
